import { Component, OnInit, inject } from '@angular/core';
import { Auth2Service } from './auth/auth2.service';
import { RouterOutlet } from '@angular/router';
import { ToastsComponent } from './shared/toasts.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, ToastsComponent]
})
export class AppComponent implements OnInit {
  readonly #auth2Service = inject(Auth2Service);

  ngOnInit() {
    this.#auth2Service.loadUser();
  }
}
